import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { LoginPage } from './pages/Login.js';
import { OverviewPage } from './pages/Overview.js';
import { LiveMapPage } from './pages/LiveMap.js';
import { TripsPage } from './pages/Trips.js';
import { DriversPage } from './pages/Drivers.js';
import { RidersPage } from './pages/Riders.js';
import { PricingPage } from './pages/Pricing.js';
import { PayoutsPage } from './pages/Payouts.js';
import { useSession } from './state/session.js';
import { IS_DEMO } from './demo/config.js';

function RequireAdmin({ children }: { children: JSX.Element }) {
  const token = useSession((s) => s.accessToken);
  const user = useSession((s) => s.user);
  const location = useLocation();
  if (!token || user?.role !== 'admin') {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return children;
}

export function App() {
  return (
    <Routes>
      <Route path="/login" element={IS_DEMO ? <Navigate to="/" replace /> : <LoginPage />} />
      <Route path="/" element={<RequireAdmin><OverviewPage /></RequireAdmin>} />
      <Route path="/live" element={<RequireAdmin><LiveMapPage /></RequireAdmin>} />
      <Route path="/trips" element={<RequireAdmin><TripsPage /></RequireAdmin>} />
      <Route path="/drivers" element={<RequireAdmin><DriversPage /></RequireAdmin>} />
      <Route path="/riders" element={<RequireAdmin><RidersPage /></RequireAdmin>} />
      <Route path="/pricing" element={<RequireAdmin><PricingPage /></RequireAdmin>} />
      <Route path="/payouts" element={<RequireAdmin><PayoutsPage /></RequireAdmin>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
